export default __webpack_public_path__ + "static/nam-ed0da86357f7972216294b446f17ba1e.png";